export let pixelValue = function(s) {	// s is "<num>px" ... returns <num> as number or 0 if it does not end with 'px'
		return (s.slice(-2) == 'px' ? +s.substring(0, s.length-2) : 0);
	}
